import React, { useState } from "react";
import { Container, Grid, Typography, Box } from "@mui/material";
import PrivacyPolicyDialog from "./PrivacyPolicy";
import TermsOfServiceDialog from "./TermsOfService";
import { PricingFlag } from "../../config";

import { useNavigate } from "react-router-dom";
const Footer = () => {
  const [privacyDialogOpen, setPrivacyDialogOpen] = useState(false);
  const [termsDialogOpen, setTermsDialogOpen] = useState(false);
  const navigate = useNavigate();
  const handleNavigation = (sectionId) => {
    navigate("/landing");
    // Wait for navigation to complete then scroll
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  const handleOpenPrivacyDialog = () => {
    setPrivacyDialogOpen(true);
  };

  const handleClosePrivacyDialog = () => {
    setPrivacyDialogOpen(false);
  };

  const handleOpenTermsDialog = () => {
    setTermsDialogOpen(true);
  };

  const handleCloseTermsDialog = () => {
    setTermsDialogOpen(false);
  };

  return (
    <>
      <Box
        component="footer"
        sx={{
          bgcolor: "#2667be",
          color: "white",
          py: 6,
          mt: 8,
          px: { xs: 2, md: 0 },
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid item xs={12} md={3}>
              <Typography variant="h6" gutterBottom>
                Hire-Best.ai
              </Typography>
              <Typography variant="body2" color="#ffe1e1">
                Intelligent, Automated & Natural AI Interviewer
              </Typography>
            </Grid>

            <Grid item xs={12} md={2}>
              <Typography variant="h6" gutterBottom>
                Product
              </Typography>
              <Typography variant="body2" color="grey.400">
                <span
                  style={{
                    cursor: "pointer",
                    color: "#ffe1e1",
                    textDecoration: "underline",
                  }}
                  onClick={() => handleNavigation("features")}
                >
                  Features
                </span>
              </Typography>
              { PricingFlag && (
                <Typography variant="body2" color="grey.400">
                <span
                  style={{
                    cursor: "pointer",
                    color: "#ffe1e1",
                    textDecoration: "underline",
                  }}
                  onClick={() => handleNavigation("pricing")}
                >
                  Pricing
                </span>
              </Typography>
              )}
            </Grid>

            <Grid item xs={12} md={2}>
              <Typography variant="h6" gutterBottom>
                Company
              </Typography>
              <Typography variant="body2" color="grey.400">
                <span
                  style={{
                    cursor: "pointer",
                    color: "#ffe1e1",
                    textDecoration: "underline",
                  }}
                  onClick={() => handleNavigation("contact")}
                >
                  Contact Us
                </span>
              </Typography>
            </Grid>

            <Grid item xs={12} md={2}>
              <Typography variant="h6" gutterBottom>
                Legal
              </Typography>
              <Typography variant="body2" color="grey.400">
                <span
                  style={{
                    cursor: "pointer",
                    color: "#ffe1e1",
                    textDecoration: "underline",
                  }}
                  onClick={handleOpenPrivacyDialog}
                >
                  Privacy Policy
                </span>
              </Typography>
              <Typography variant="body2" color="grey.400">
                <span
                  style={{
                    cursor: "pointer",
                    color: "#ffe1e1",
                    textDecoration: "underline",
                  }}
                  onClick={handleOpenTermsDialog}
                >
                  Terms of Service
                </span>
              </Typography>
            </Grid>

            {/* New Social Media Section */}
            <Grid item xs={12} md={3}>
              <Typography variant="h6" gutterBottom>
                Follow Us
              </Typography>
              <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                <Box
                  component="a"
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: "white", "&:hover": { color: "lightgrey" } }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                  </svg>
                </Box>
                <Box
                  component="a"
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: "white", "&:hover": { color: "lightgrey" } }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z" />
                  </svg>
                </Box>
                <Box
                  component="a"
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: "white", "&:hover": { color: "lightgrey" } }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 2.04c-5.5 0-10 4.49-10 10.02 0 5 3.66 9.15 8.44 9.9v-7H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7a10 10 0 0 0 8.44-9.9c0-5.53-4.5-10.02-10-10.02z" />
                  </svg>
                </Box>
                <Box
                  component="a"
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: "white", "&:hover": { color: "lightgrey" } }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z" />
                  </svg>
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Typography
            variant="body2"
            color="grey.400"
            align="center"
            sx={{ mt: 4, pt: 4, borderTop: 1, borderColor: "grey.800" }}
          >
            © 2025 Hire-Best.ai. All rights reserved.
          </Typography>
        </Container>
      </Box>

      {/* Dialogs */}
      <PrivacyPolicyDialog
        open={privacyDialogOpen}
        onClose={handleClosePrivacyDialog}
      />

      <TermsOfServiceDialog
        open={termsDialogOpen}
        onClose={handleCloseTermsDialog}
      />
    </>
  );
};

export default Footer;
